import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useSessionManager from '@afosto/auth-react/useSessionManager';
import LogRocket from 'logrocket';
import { FormattedMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '../Dialog';
import translations from './translations';

const SessionErrorDialog = ({ isOpen, error }) => {
  const sessionManager = useSessionManager();

  useEffect(() => {
    if (isOpen) {
      LogRocket.captureMessage('Session error', {
        extra: {
          error: error ? JSON.stringify(error) : '',
        },
      });
    }
  }, [isOpen, error]);

  return (
    <Dialog open={isOpen} fullWidth>
      <DialogTitle>
        <FormattedMessage {...translations.title} />
      </DialogTitle>
      <DialogContent>
        <FormattedMessage {...translations.description} />
        <Box mt={2}>
          <FormattedMessage {...translations.supportDescription} />
        </Box>
        <Box my={1}>
          <a href="https://afosto.com/contact/">https://afosto.com/contact</a>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={() => sessionManager.signOut()}>
          <FormattedMessage {...translations.actions.loginAgain} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

SessionErrorDialog.propTypes = {
  isOpen: PropTypes.bool,
  error: PropTypes.object,
};

SessionErrorDialog.defaultProps = {
  isOpen: false,
  error: undefined,
};

export default SessionErrorDialog;
